// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
}

.header {
  font-size: 2.5em;
  /* margin-bottom: 0.5em; */
  background: white;
  height: 80px;
  width: 100%;
  box-shadow: 0 10px 8px -6px #D3D3D3;
  color: #1D2B45;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  padding-top: 20px;
  margin: 0;

}

.headerText {
  margin-left: 40px;
  /* Adjust this value as needed */
  font-weight: bold;
  color: #1D2B45;
  margin-top: 10px;

}


/* input design */
.search-input-container {
  position: relative;
  display: flex;
  align-items: center;
  margin-left: 20px;
  width: 80%;
  margin-top: 20px;
}

.search-icon {
  /* margin-right: 40px; */
  position: absolute;
  right: 20px;
 

}

.search-input {
  padding-left: 10px; /* Adjust the padding to accommodate the icon */
  height: 40px;
  width: 100%;
  border: 1px solid #D3D3D3;
 
  border-radius: 5px;
}






/* input ends */


.searchContainer {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  padding: 20px;
  margin-left: 150px;
  /* background-color: red; */
}

.heading{
  margin-left: 20px;
  margin-bottom: 0;
}

.description {
  text-align: left;
  margin-left: 20px;
  font-size: 0.9em;
  max-width: 800px;
  color: black;
  font-weight: 500;
  /* background: yellow; */
}

.searchInputContainer {
  display: flex;
  margin: 20px;
}

.searchInput {
  padding: 10px;
  margin-right: 10px;
  font-size: 1em;
  flex: 1 1;
  max-width: 300px; /* Adjust as needed */
  
}

.searchButton {
  padding: 10px 20px;
  font-size: 1em;
  cursor: pointer;
}

.radioButtonsContainer {
  margin: 20px;
}

.radioLabel {
  margin-right: 30px;
  font-size: 1em;
  cursor: pointer;
  color: black;
  font-weight: 700;
}



.footer {
  font-size: 0.8em;
  text-align: center;
  /* padding: 10px; */
  position: absolute;
  bottom: 0;
  width: 100%;
  color: white;
  background: #1D2B45;
  display: flex;
  justify-content: center;
  align-items: center;
}

.footerText {
  max-width: 640px;
  color: white;
  padding-top: 8px;
  padding-bottom: 10px;
  /* margin-top: 20px; */
}
.lastText{
  margin-top: 8px;
}


/* book search css style */

/* .search-results {
  margin-top: 20px;
  max-height: 300px;
  overflow-y: auto; 
}

.search-result {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  margin-left: 20px;
  border-bottom: 1px solid #ccc;

}

.book-title {
  flex: 1;
  font-size: 1em;
}

.book-author {
  flex: 1;
  font-size: 1em;
  text-align: right;
}

.pdf-button {
  background-color: #4CAF50;
  color: white;
  padding: 10px 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 1em;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 5px;
} */


/* new design */

.search-results {
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  
  max-height: 300px; 
  overflow-y: auto;  
  border-top: 1px solid #ccc;
}

.search-result-header {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  background-color: #f8f9fa;
  border-bottom: 2px solid #dee2e6; 
  position: sticky;
  top: 0;
  /* margin-left: 30px; */
}


.search-result-title, .search-result-author,.search-result-author-header, .pdf-button-header {
  font-weight: bold;
  padding-left: 20px; 
}

.search-result-title {
  flex-basis: 50%;
}

.search-result-author {
  flex-basis: 50%;
  text-align: right;
  padding-right: 20px; 
}

.search-result-author-header {
  flex-basis: 50%;
  text-align: right;
  padding-right: 20px; 
}




.search-result-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ccc;
  padding: 10px 0;
}

.pdf-button-header {
  
  margin-left: 20px; 
  padding-right: 20px;
}


.pdf-button {
  background-color: #007bff; 
  color: white;
  padding: 5px 15px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 0.875em;
  border: none;
  border-radius: 4px;
  margin-left: 20px; 
  cursor: pointer;
}
.search-result-header, .search-result-row {
  display: flex;
  align-items: center;
}

.search-result-title, .search-result-author, .pdf-button-header {
  font-weight: bold;
  flex-grow: 1;
  text-align: center;
}
 
.search-result-author-header {
  font-weight: bold;
  flex-grow: 1;
  text-align: left;
  margin-left: 20px;
}

.search-result-title {
  flex-grow: 2; /* Allows the title to take up twice as much space as the author */
  text-align: left;
  padding-left: 20px;
}

.search-result-author {
  flex-grow: 3; /* Gives the author the most space, centering it */
  text-align: left;
  /* margin-left: 10px; */
}



.search-result-row .pdf-button {
  flex-grow: 0; /* Prevents the PDF button from taking up additional space */
  margin-left: 20px; /* Spacing between the author and the PDF button */
  padding-right: 20px; /* Optional, for aligning with the right edge */
}

.pdf-button-header {
  /* This header is for alignment with the PDF button, it should not grow */
  flex-grow: 0;
  padding-right: 20px; /* Match the padding of the actual buttons for alignment */
}
.no-results {
  text-align: center;
  padding: 20px;
  font-weight: bold;
}

.pdf-click{
  display: flex;
}
.pdf-text {
    margin-left: 5px;
    font-size: 12px;
}
* {
  /* margin: 0; */
  /* padding: 0; */
  /* box-sizing: border-box; */
  text-decoration: none; /* Remove underline for all elements */
}

/* dropdown styles */
.suggestions-dropdown {
  position: absolute;
  background-color: #fff;
  width: calc(100% - 2px); /* Adjust width based on the input field */
  border: 1px solid #ccc;
  border-top: none;
  top: 100%;
  z-index: 10;
  max-height: 200px; /* Adjust based on the desired maximum height */
  overflow-y: auto;
}

.suggestion {
  padding: 10px;
  cursor: pointer;
}

.suggestion:hover {
  background-color: #f2f2f2;
}
.suggestion.highlighted {
  background-color: #f0f0f0; /* Adjust the background color as needed */
}



/* ********************************************MOBILE RESPONSIVE CHANGES */


/* Global adjustments for box-sizing and text-decoration */
* {
  box-sizing: border-box;
  text-decoration: none; /* Ensures consistent styling of links */
}

/* Responsive font sizes using root ems */
html {
  font-size: 16px; /* Adjust base font size as needed */
}

@media (max-width: 768px) {
  html {
    font-size: 13px; /* Smaller font size on smaller devices */
  }
}

/* Media query for mobile devices */
@media (max-width: 600px) {
  .header {
    font-size: 1.5em; /* Adjust header size for mobile */
    /* justify-content: center; Center header content */
    padding: 10px 0; /* Adjust padding */
  }

  /* .heading{
   margin-left:
  } */

  .search-icon{
    margin-top: 10px;
  }

  .headerText, .footerText, .lastText {
    margin-left: 20px; 
  }

  .searchContainer, .search-results, .description {
    margin-left: 10px; /* Adjust margin for content */
    margin-right: 10px; /* Add right margin for spacing */
    padding: 10px 0; /* Adjust padding for content */
  }

  .search-input-container, .radioButtonsContainer, .search-results {
    flex-direction: column; /* Stack elements vertically */
    width: 90%; /* Use more of the screen width */
    margin: 10px auto; /* Center elements */
  }

  .suggestions-dropdown {
    width: 100%; /* Adjust dropdown width to match input field */
  }
}

/* Adjusting footer to avoid absolute positioning on mobile */
@media (max-width: 400px) {
  .footer {
    /* position: relative; Avoid absolute positioning on small screens */
    font-size: 0.7em; /* Adjust font size for readability */
  /* position: sticky; */

  }
}



`, "",{"version":3,"sources":["webpack://./src/styles/searchScreen.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,mCAAmC;EACnC,cAAc;EACd,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;;EAEnB,iBAAiB;EACjB,SAAS;;AAEX;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,iBAAiB;EACjB,cAAc;EACd,gBAAgB;;AAElB;;;AAGA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,WAAW;;;AAGb;;AAEA;EACE,kBAAkB,EAAE,+CAA+C;EACnE,YAAY;EACZ,WAAW;EACX,yBAAyB;;EAEzB,kBAAkB;AACpB;;;;;;;AAOA,eAAe;;;AAGf;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,SAAO;EACP,gBAAgB,EAAE,qBAAqB;;AAEzC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;;;AAIA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;;;AAGA,0BAA0B;;AAE1B;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAsCG;;;AAGH,eAAe;;AAEf;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;;EAEjB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,yBAAyB;EACzB,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;EACN,uBAAuB;AACzB;;;AAGA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;;;;AAKA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;AACrB;;;AAGA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY,EAAE,kEAAkE;EAChF,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY,EAAE,kDAAkD;EAChE,gBAAgB;EAChB,uBAAuB;AACzB;;;;AAIA;EACE,YAAY,EAAE,4DAA4D;EAC1E,iBAAiB,EAAE,kDAAkD;EACrE,mBAAmB,EAAE,+CAA+C;AACtE;;AAEA;EACE,yEAAyE;EACzE,YAAY;EACZ,mBAAmB,EAAE,0DAA0D;AACjF;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB,EAAE,sCAAsC;AAC/D;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB,EAAE,0CAA0C;EACnE,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,iBAAiB,EAAE,+CAA+C;EAClE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB,EAAE,0CAA0C;AACvE;;;;AAIA,0EAA0E;;;AAG1E,0DAA0D;AAC1D;EACE,sBAAsB;EACtB,qBAAqB,EAAE,wCAAwC;AACjE;;AAEA,yCAAyC;AACzC;EACE,eAAe,EAAE,oCAAoC;AACvD;;AAEA;EACE;IACE,eAAe,EAAE,yCAAyC;EAC5D;AACF;;AAEA,mCAAmC;AACnC;EACE;IACE,gBAAgB,EAAE,kCAAkC;IACpD,mDAAmD;IACnD,eAAe,EAAE,mBAAmB;EACtC;;EAEA;;KAEG;;EAEH;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB,EAAE,8BAA8B;IACjD,kBAAkB,EAAE,iCAAiC;IACrD,eAAe,EAAE,+BAA+B;EAClD;;EAEA;IACE,sBAAsB,EAAE,8BAA8B;IACtD,UAAU,EAAE,iCAAiC;IAC7C,iBAAiB,EAAE,oBAAoB;EACzC;;EAEA;IACE,WAAW,EAAE,+CAA+C;EAC9D;AACF;;AAEA,6DAA6D;AAC7D;EACE;IACE,oEAAoE;IACpE,gBAAgB,EAAE,qCAAqC;EACzD,sBAAsB;;EAEtB;AACF","sourcesContent":["body {\n  margin: 0;\n  padding: 0;\n}\n\n.header {\n  font-size: 2.5em;\n  /* margin-bottom: 0.5em; */\n  background: white;\n  height: 80px;\n  width: 100%;\n  box-shadow: 0 10px 8px -6px #D3D3D3;\n  color: #1D2B45;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n\n  padding-top: 20px;\n  margin: 0;\n\n}\n\n.headerText {\n  margin-left: 40px;\n  /* Adjust this value as needed */\n  font-weight: bold;\n  color: #1D2B45;\n  margin-top: 10px;\n\n}\n\n\n/* input design */\n.search-input-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n  margin-left: 20px;\n  width: 80%;\n  margin-top: 20px;\n}\n\n.search-icon {\n  /* margin-right: 40px; */\n  position: absolute;\n  right: 20px;\n \n\n}\n\n.search-input {\n  padding-left: 10px; /* Adjust the padding to accommodate the icon */\n  height: 40px;\n  width: 100%;\n  border: 1px solid #D3D3D3;\n \n  border-radius: 5px;\n}\n\n\n\n\n\n\n/* input ends */\n\n\n.searchContainer {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n  margin-left: 150px;\n  /* background-color: red; */\n}\n\n.heading{\n  margin-left: 20px;\n  margin-bottom: 0;\n}\n\n.description {\n  text-align: left;\n  margin-left: 20px;\n  font-size: 0.9em;\n  max-width: 800px;\n  color: black;\n  font-weight: 500;\n  /* background: yellow; */\n}\n\n.searchInputContainer {\n  display: flex;\n  margin: 20px;\n}\n\n.searchInput {\n  padding: 10px;\n  margin-right: 10px;\n  font-size: 1em;\n  flex: 1;\n  max-width: 300px; /* Adjust as needed */\n  \n}\n\n.searchButton {\n  padding: 10px 20px;\n  font-size: 1em;\n  cursor: pointer;\n}\n\n.radioButtonsContainer {\n  margin: 20px;\n}\n\n.radioLabel {\n  margin-right: 30px;\n  font-size: 1em;\n  cursor: pointer;\n  color: black;\n  font-weight: 700;\n}\n\n\n\n.footer {\n  font-size: 0.8em;\n  text-align: center;\n  /* padding: 10px; */\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  color: white;\n  background: #1D2B45;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.footerText {\n  max-width: 640px;\n  color: white;\n  padding-top: 8px;\n  padding-bottom: 10px;\n  /* margin-top: 20px; */\n}\n.lastText{\n  margin-top: 8px;\n}\n\n\n/* book search css style */\n\n/* .search-results {\n  margin-top: 20px;\n  max-height: 300px;\n  overflow-y: auto; \n}\n\n.search-result {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px;\n  margin-left: 20px;\n  border-bottom: 1px solid #ccc;\n\n}\n\n.book-title {\n  flex: 1;\n  font-size: 1em;\n}\n\n.book-author {\n  flex: 1;\n  font-size: 1em;\n  text-align: right;\n}\n\n.pdf-button {\n  background-color: #4CAF50;\n  color: white;\n  padding: 10px 20px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 1em;\n  margin: 4px 2px;\n  cursor: pointer;\n  border-radius: 5px;\n} */\n\n\n/* new design */\n\n.search-results {\n  display: flex;\n  flex-direction: column;\n  margin-left: 20px;\n  \n  max-height: 300px; \n  overflow-y: auto;  \n  border-top: 1px solid #ccc;\n}\n\n.search-result-header {\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 0;\n  background-color: #f8f9fa;\n  border-bottom: 2px solid #dee2e6; \n  position: sticky;\n  top: 0;\n  /* margin-left: 30px; */\n}\n\n\n.search-result-title, .search-result-author,.search-result-author-header, .pdf-button-header {\n  font-weight: bold;\n  padding-left: 20px; \n}\n\n.search-result-title {\n  flex-basis: 50%;\n}\n\n.search-result-author {\n  flex-basis: 50%;\n  text-align: right;\n  padding-right: 20px; \n}\n\n.search-result-author-header {\n  flex-basis: 50%;\n  text-align: right;\n  padding-right: 20px; \n}\n\n\n\n\n.search-result-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #ccc;\n  padding: 10px 0;\n}\n\n.pdf-button-header {\n  \n  margin-left: 20px; \n  padding-right: 20px;\n}\n\n\n.pdf-button {\n  background-color: #007bff; \n  color: white;\n  padding: 5px 15px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 0.875em;\n  border: none;\n  border-radius: 4px;\n  margin-left: 20px; \n  cursor: pointer;\n}\n.search-result-header, .search-result-row {\n  display: flex;\n  align-items: center;\n}\n\n.search-result-title, .search-result-author, .pdf-button-header {\n  font-weight: bold;\n  flex-grow: 1;\n  text-align: center;\n}\n \n.search-result-author-header {\n  font-weight: bold;\n  flex-grow: 1;\n  text-align: left;\n  margin-left: 20px;\n}\n\n.search-result-title {\n  flex-grow: 2; /* Allows the title to take up twice as much space as the author */\n  text-align: left;\n  padding-left: 20px;\n}\n\n.search-result-author {\n  flex-grow: 3; /* Gives the author the most space, centering it */\n  text-align: left;\n  /* margin-left: 10px; */\n}\n\n\n\n.search-result-row .pdf-button {\n  flex-grow: 0; /* Prevents the PDF button from taking up additional space */\n  margin-left: 20px; /* Spacing between the author and the PDF button */\n  padding-right: 20px; /* Optional, for aligning with the right edge */\n}\n\n.pdf-button-header {\n  /* This header is for alignment with the PDF button, it should not grow */\n  flex-grow: 0;\n  padding-right: 20px; /* Match the padding of the actual buttons for alignment */\n}\n.no-results {\n  text-align: center;\n  padding: 20px;\n  font-weight: bold;\n}\n\n.pdf-click{\n  display: flex;\n}\n.pdf-text {\n    margin-left: 5px;\n    font-size: 12px;\n}\n* {\n  /* margin: 0; */\n  /* padding: 0; */\n  /* box-sizing: border-box; */\n  text-decoration: none; /* Remove underline for all elements */\n}\n\n/* dropdown styles */\n.suggestions-dropdown {\n  position: absolute;\n  background-color: #fff;\n  width: calc(100% - 2px); /* Adjust width based on the input field */\n  border: 1px solid #ccc;\n  border-top: none;\n  top: 100%;\n  z-index: 10;\n  max-height: 200px; /* Adjust based on the desired maximum height */\n  overflow-y: auto;\n}\n\n.suggestion {\n  padding: 10px;\n  cursor: pointer;\n}\n\n.suggestion:hover {\n  background-color: #f2f2f2;\n}\n.suggestion.highlighted {\n  background-color: #f0f0f0; /* Adjust the background color as needed */\n}\n\n\n\n/* ********************************************MOBILE RESPONSIVE CHANGES */\n\n\n/* Global adjustments for box-sizing and text-decoration */\n* {\n  box-sizing: border-box;\n  text-decoration: none; /* Ensures consistent styling of links */\n}\n\n/* Responsive font sizes using root ems */\nhtml {\n  font-size: 16px; /* Adjust base font size as needed */\n}\n\n@media (max-width: 768px) {\n  html {\n    font-size: 13px; /* Smaller font size on smaller devices */\n  }\n}\n\n/* Media query for mobile devices */\n@media (max-width: 600px) {\n  .header {\n    font-size: 1.5em; /* Adjust header size for mobile */\n    /* justify-content: center; Center header content */\n    padding: 10px 0; /* Adjust padding */\n  }\n\n  /* .heading{\n   margin-left:\n  } */\n\n  .search-icon{\n    margin-top: 10px;\n  }\n\n  .headerText, .footerText, .lastText {\n    margin-left: 20px; \n  }\n\n  .searchContainer, .search-results, .description {\n    margin-left: 10px; /* Adjust margin for content */\n    margin-right: 10px; /* Add right margin for spacing */\n    padding: 10px 0; /* Adjust padding for content */\n  }\n\n  .search-input-container, .radioButtonsContainer, .search-results {\n    flex-direction: column; /* Stack elements vertically */\n    width: 90%; /* Use more of the screen width */\n    margin: 10px auto; /* Center elements */\n  }\n\n  .suggestions-dropdown {\n    width: 100%; /* Adjust dropdown width to match input field */\n  }\n}\n\n/* Adjusting footer to avoid absolute positioning on mobile */\n@media (max-width: 400px) {\n  .footer {\n    /* position: relative; Avoid absolute positioning on small screens */\n    font-size: 0.7em; /* Adjust font size for readability */\n  /* position: sticky; */\n\n  }\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
